module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAISE FOR ")]), _vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LENA ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERRANTE’S ")]), _vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EAPOLITAN ")]), _vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVELS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM THE ")]), _vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante’s writing is so unencumbered, so natural, and yet so lovely, brazen, and flush. The constancy of detail and the pacing that zips and skips then slows to a real-time crawl have an almost psychic effect, bringing you deeply into synchronicity with the discomforts and urgency of the characters’ emotions. Ferrante is unlike other writers—not because she’s innovative, but rather because she’s unselfconscious and brutally, diligently honest.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Minna Proctor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bookforum")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Everyone should read anything with Ferrante’s name on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boston Globe")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“In these bold, gorgeous, relentless novels, Ferrante traces the deep connections between the political and the domestic. This is a new version of the way we live now—one we need, one told brilliantly, by a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Roxana Robinson"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“An intoxicatingly furious portrait of enmeshed friends Lila and Elena, bright and passionate girls from a raucous neighborhood in world-class Naples. Ferrante writes with such aggression and unnerving psychological insight about the messy complexity of female friendship that the real world can drop away when you’re reading her.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Entertainment Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante can do a woman’s interior dialogue like no one else, with a ferocity that is shockingly honest, unnervingly blunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante’s gutsy and compulsively readable new novel, the first of a quartet, is a terrific entry point for Americans unfamiliar with the famously reclusive writer, whose go-for-broke tales of women’s shadow selves—those ambivalent mothers and seething divorcées too complex or unseemly for polite society (and most literary fiction, for that matter)—shimmer with Balzacian human detail and subtle psychological suspense . . . The Neapolitan novels offer one of the more nuanced portraits of feminine friendship in recent memory—from the make-up and break-up quarrels of young girls to the way in which we carefully define ourselves against each other as teens—Ferrante wisely balances her memoir-like emotional authenticity with a wry sociological understanding of a society on the verge of dramatic change.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Megan O’Grady, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vogue")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante will blow you away.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Alice Sebold")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“An engrossing, wildly original contemporary epic about the demonic power of human (and particularly female) creativity checked by the forces of history and society.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Los Angeles Review of Books")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Brilliant Friend ")]), _vm._v("is a sweeping family-centered epic that encompasses issues of loyalty, love, and a transforming Europe. This gorgeous novel should bring a host of new readers to one of Italy’s most acclaimed authors.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Barnes and Noble Review")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“[Ferrante’s Neapolitan Novels] don’t merely offer a teeming vision of working-class Naples, with its cobblers and professors, communists and mobbed-up businessmen, womanizing poets and downtrodden wives; they present one of modern fiction’s richest portraits of a friendship.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—John Powers, “Fresh Air”, NPR")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante tackles girlhood and friendship with amazing force.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Gwyneth Paltrow")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante draws an indelible picture of the city’s mean streets and the poverty, violence and sameness of lives lived in the same place forever . . . She is a fierce writer.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shelf Awareness")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante transforms the love, separation and reunion of two poor urban girls into the general tragedy of their city.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante: the best angry woman writer ever!”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—John Waters")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Beautifully translated by Ann Goldstein . . . Ferrante writes with a ferocious, intimate urgency that is a celebration of anger. Ferrante is terribly good with anger, a very specific sort of wrath harbored by women, who are so often not allowed to give voice to it. We are angry, a lot of the time, at the position we’re in—whether it’s as wife, daughter, mother, friend—and I can think of no other woman writing who is so swift and gorgeous in this rage, so bracingly fearless in mining fury.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Susanna Sonnenberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The San Francisco Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“The through-line in all of Ferrante’s investigations, for me, is nothing less than one long, mind-and-heart-shredding howl for the history of women (not only Neapolitan women), and its implicit "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j’accuse")]), _vm._v(" . . . Ferrante’s effect, critics agree, is inarguable. ‘Intensely, violently personal’ and ‘brutal directness, familial torment’ is how James Wood ventures to categorize her—descriptions that seem mild after you’ve encountered the work.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Joan Frank, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The San Francisco Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Lila, mercurial, unsparing, and, at the end of this first episode in a planned trilogy from Ferrante, seemingly capable of starting a full-scale neighborhood war, is a memorable character.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante’s own writing has no limits, is willing to take every thought forward to its most radical conclusion and backward to its most radical birthing.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Yorker")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM THE ")]), _vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED ")]), _vm._v("K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INGDOM")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Nothing"), _c('em', {
    staticClass: "italic"
  }), _vm._v("quite"), _c('em', {
    staticClass: "italic"
  }), _vm._v("like"), _c('em', {
    staticClass: "italic"
  }), _vm._v("it"), _c('em', {
    staticClass: "italic"
  }), _vm._v("has ever been published.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—The Guardian")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Story of a New Name")]), _vm._v(", like its predecessor, is fiction of the very highest order.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independent on Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Brilliant Friend")]), _vm._v(", translated by Ann Goldstein, is stunning: an intense, forensic exploration of the friendship between Lila and the story’s narrator, Elena. Ferrante’s evocation of the working-class district of Naples where Elena and Lila first meet as two wiry eight-year-olds is cinematic in the density of its detail.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times Literary Supplement")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“This is a story about friendship as a mass of roiling currents—love, envy, pity, spite, dependency and Schadenfreude coiling around one another, tricky to untangle.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Intelligent Life")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante may be the best contemporary novelist you have never heard of. The Italian author has written six lavishly praised novels. But she writes under a pseudonym and will not offer herself for public consumption. Her characters likewise defy convention . . . Her prose is crystal, and her storytelling both visceral and compelling.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Economist")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM ")]), _vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TALY")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Those Who Leave and Those Who Stay")]), _vm._v(" evokes the vital flux of a heartbeat, of blood flowing through our veins.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Repubblica")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“We don’t know who she is, but it doesn’t matter. Ferrante’s books are enthralling self-contained monoliths that do not seek friendship but demand silent, fervid admiration from her passionate readers . . . The thing most real in these novels is the intense, almost osmotic relationship that unites Elena and Lila, the two girls from a neighborhood in Naples who are the peerless protagonists of the Neapolitan novels.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Famiglia Cristiana")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v(" “Today it is near impossible to find writers capable of bringing smells, tastes, feelings, and contradictory passions to their pages. Elena Ferrante, alone, seems able to do it. There is no writer better suited to composing the great Italian novel of her generation, her country, and her time.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Il Manifesto")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Regardless of who is behind the name Elena Ferrante, the mysterious pseudonym used by the author of the Neapolitan novels, two things are certain: she is a woman and she knows how to describe Naples like nobody else. She does so with a style that recalls an enchanted spider web with its expressive power and the wizardry with which it creates an entire world.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Huffington Post")]), _vm._v(" (Italy)")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“A marvel that is without limits and beyond genre.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Il Salvagente")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante is proving that literature can cure our present ills; it can cure the spirit by operating as an antidote to the nervous attempts we make to see ourselves reflected in the present-day of a country that is increasingly repellent.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Il Mattino")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Brilliant Friend")]), _vm._v(" flows from the soul like an eruption from Mount Vesuvius.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Repubblica")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM ")]), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USTRALIA")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“No one has a voice quite like Ferrante’s. Her gritty, ruthlessly frank novels roar off the page with a barbed fury, like an attack that is also a defense . . . Ferrante’s fictions are fierce, unsentimental glimpses at the way a woman is constantly under threat, her identity submerged in marriage, eclipsed by motherhood, mythologised by desire. Imagine if Jane Austen got angry and you’ll have some idea of how explosive these works are.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—John Freeman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Australian")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“One of the most astounding—and mysterious—contemporary Italian novelists available in translation, Elena Ferrante unfolds the tumultuous inner lives of women in her thrillingly menacing stories of lost love, negligent mothers and unfulfilled desires.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Age")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Ferrante bewitches with her tiny, intricately drawn world . . . "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Brilliant Friend")]), _vm._v(" journeys fearlessly into some of that murkier psychological territory where questions of individual identity are inextricable from circumstance and the ever-changing identities of others.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Melbourne Review")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“The Neapolitan novels move far from contrivance, logic or respectability to ask uncomfortable questions about how we live, how we love, how we singe an existence in a deeply flawed world that expects pretty acquiescence from its women. In all their beauty, their ugliness, their devotion and deceit, these girls enchant and repulse, like life, like our very selves.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sydney Morning Herald")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Elena Ferrante’s female characters are genuine works of art . . . It is clear that her novel is the child of Italian neorealism and an abiding fascination with scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("El Pais")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e88f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/neapolitan-novels-boxed-set_00000.vue
// module id = 66
// module chunks = 0